<script>
  import getTranslation from '../../../utilities/getTranslation';

  export let isMostPopular, subscription, showOffer, hasOfferTerms;
</script>

<style lang="scss">
  @use './styles/sharedStyles' as *;
  @use '../index' as *;

  .card {
    @include generalCardStyle;
  }

  .header {
    padding: spacing(2);
    padding-block-start: 1.1rem;
    font-size: 2.6rem;
    line-height: 3.2rem;
    letter-spacing: -0.0112em;
    margin: 0;
    justify-content: flex-end;

    @include mq($until: desktop) {
      margin-block-start: -0.2rem;
    }

    &.with-highlight-banner {
      padding-block-start: 1.6rem;
    }
  }
</style>

<h3
  class="card header"
  class:most-popular-border={isMostPopular}
  class:with-highlight-banner={hasOfferTerms && showOffer}
>
  {getTranslation(subscription.informationKeys, 'description.title.v2')}
</h3>
